import { gql, MutationTuple, useMutation } from '@apollo/client';

export const SET_MFA_AUTHENTICATION_BY_USER_ID = gql`
  mutation SetMFAAuthenticationByUserId($mfaAuthentication: Boolean!) {
    setMFAAuthenticationByUserId(mfaAuthentication: $mfaAuthentication) {
      success
      message
      nextAttempt
    }
  }
`;

export interface ISetMFAAuthenticationByUserIdParams {
  mfaAuthentication: boolean;
}

export interface ISetMFAAuthenticationByUserIdResponse {
  setMFAAuthenticationByUserId: {
    success: boolean;
    message?: string;
    nextAttempt?: string;
  };
}

export const useSetMFAAuthenticationByUserId = (): MutationTuple<
  ISetMFAAuthenticationByUserIdResponse,
  ISetMFAAuthenticationByUserIdParams
> =>
  useMutation<ISetMFAAuthenticationByUserIdResponse, ISetMFAAuthenticationByUserIdParams>(
    SET_MFA_AUTHENTICATION_BY_USER_ID,
  );
